function startLandingAnimation() {
  const landingMask = document.getElementById('landingMask');
  const bodyContainer = document.querySelector('.body-container');

  if (!sessionStorage.getItem('visited')) {
    landingMask.style.display = 'flex';
    bodyContainer.style.position = 'absolute';
    bodyContainer.style.overflow = 'hidden';
    bodyContainer.style.clipPath = 'circle(0% at center)';
    bodyContainer.style.animation = 'holeExpand1 1s 2s forwards, holeExpand2 1s 3s forwards';

    setTimeout(() => {
        landingMask.style.display = 'none';
        bodyContainer.style.position = 'relative';
    }, 3500);

    sessionStorage.setItem('visited', 'true');
  }

  bodyContainer.style.opacity = '1';
}

window.addEventListener('load', startLandingAnimation);